import React, { useEffect, useState } from "react";
import NoFooterModal from "../Common/NoFooterModal";
import Input from "sushiweb/InputTypes/Input";
import { BottomSectionModal } from "../../constants/assets/containers";
import Button from "sushiweb/Button";

const MerchantFacadeFilterModal = ({
  handleClose,
  getMerchantFacadePictures,
  activeFilters,
  resetState,
}) => {
  const [merchantId, setMerchantId] = useState("");

  const handleChange = (val) => {
    setMerchantId(val);
  };

  const handleSubmit = () => {
    if (merchantId) {
      const pageRequest = {
        page: 1,
        page_size: 10,
      };
      const filters = {
        merchant_external_id: merchantId,
      };
      getMerchantFacadePictures(filters, pageRequest).then(() => {
        handleClose();
      });
    }
  };

  const handleClearFilters = () => {
    const pageRequest = {
      page: 1,
      page_size: 10,
    };
    getMerchantFacadePictures({}, pageRequest).then((res) => {
      resetState({ state: "activeFilters" });
      handleClose();
    });
  };

  useEffect(() => {
    if (activeFilters) {
      setMerchantId(activeFilters.merchant_external_id);
    }
  }, [activeFilters]);

  return (
    <NoFooterModal
      header={true}
      heading="Filter facade pictures"
      handleClose={handleClose}
      id="MerchantFacadeFormModal"
      modalButtons={
        <BottomSectionModal className="flex items-center justify-between">
          <Button
            data-testid="filterMerchantFacadeBtn"
            onClick={handleClearFilters}
            disabled={activeFilters && !activeFilters.merchant_external_id}
            className="sushi-btn"
          >
            Clear
          </Button>
          <Button
            data-testid="submitButtonMerchantFacadeFilters"
            className="sushi-btn"
            disabled={!merchantId}
            onClick={handleSubmit}
          >
            Apply
          </Button>
        </BottomSectionModal>
      }
    >
      <Input
        value={merchantId}
        data-testid="MerchantExternalIdInput"
        id="sushi-input"
        onChange={(e) => handleChange(e)}
        label="Merchant external Id"
      />
    </NoFooterModal>
  );
};

export default MerchantFacadeFilterModal;
